<div mat-dialog-header class="title">
    Add Material Type
</div>

<div mat-dialog-content>
    <div class="flex-column">
        <mat-form-field>
            <mat-label>Material Type</mat-label>
            <div *ngIf="!(selectedClient$|async)">
                <mat-spinner strokeWidth="4" [diameter]="30"></mat-spinner>
            </div>
            <mat-chip-grid #chipGrid aria-label="Enter material type keywords">
                <mat-chip-row *ngFor="let materialType of materialTypesArray"
                    (removed)="removeMaterialType(materialType)" [style.background-color]="materialType.color">
                    {{ materialType.text }}
                    <button matChipRemove aria-label="'remove material type ' + materialType.text">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </mat-chip-grid>
            <div class="flex-row input-wrapper">
                <input placeholder="Add new material type..." [matChipInputFor]="chipGrid"
                    (matChipInputTokenEnd)="addMaterialType($event)" (input)="onInputChange($event)"
                    [(ngModel)]="newMaterialType" />
                <div class="flex">
                    <input type="color" [(ngModel)]="color" />
                </div>
            </div>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!valid()" (click)="save()">Save</button>
</div>